var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6061 3.46252C12.3195 2.11886 10.2707 2.00038 8.85029 3.18726L7.9998 3.89811L7.1493 3.18726C5.72887 2.00038 3.68007 2.11886 2.39346 3.46252C1.08307 4.83101 1.00359 6.99405 2.23178 8.39021C3.30034 9.60617 4.54551 10.9527 5.66637 11.9906C6.22816 12.5106 6.74307 12.9391 7.17851 13.2335C7.64859 13.5506 7.91149 13.6308 7.9998 13.6308C8.08811 13.6308 8.351 13.5506 8.82108 13.2335C9.25652 12.9391 9.77143 12.5106 10.3332 11.9906C11.4541 10.9527 12.6993 9.60617 13.7678 8.39021C14.9953 6.99405 14.9165 4.83101 13.6061 3.46252ZM8.00136 2.07875C9.9632 0.440678 12.7905 0.603847 14.5669 2.45829C16.365 4.33686 16.5145 7.364 14.7686 9.34969C13.6892 10.5777 12.4074 11.9661 11.2349 13.0522C10.65 13.5942 10.0766 14.0745 9.55834 14.4249C9.07535 14.7513 8.51899 15.0492 8 15.0492C7.48101 15.0492 6.92465 14.7513 6.44167 14.4249C5.92335 14.0745 5.35002 13.5942 4.76513 13.0522C3.59264 11.9661 2.31079 10.5777 1.23136 9.34969C-0.514459 7.364 -0.365011 4.33686 1.43312 2.45829C3.20951 0.603847 6.0368 0.440678 7.99864 2.07875L8 2.08017L8.00136 2.07875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfavorite);
export default __webpack_public_path__ + "static/media/unfavorite.19d834542d5be15b3d9d3f2cc9c9717b.svg";
export { ForwardRef as ReactComponent };